import React, { Fragment, useContext, useEffect, useState } from "react";
import SocketContext from "../../../../context/SocketContext";

export default function High(props) {
  const symbol_id = props.symbol_id;
  const socket = useContext(SocketContext);

  const [High, setHigh] = useState(0);

  useEffect(() => {
    socket.emit("giverate", symbol_id);
    socket.on("trade" + symbol_id, trade);
    return () => {
      socket.off("trade" + symbol_id, trade);
    };
  }, []);

  const trade = (data) => {
    if (data != null) {
      if (High !== data.High) {
        setHigh(data.High);
      }
    }
  };

  return (
    <Fragment>
      <div className="bid">High</div>
      <div className="bidprice">{High}</div>
    </Fragment>
  );
}
